import { change, reset } from 'redux-form'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import { activateGoogleOptimize } from 'actions/thirdParty'
import StoreLocatorNoResults from './StoreLocatorNoResults'
import { LOCATION_FINDER_FORM, LOCATION_FINDER_INPUT } from 'constant'

const withUseMyLocationClickedState = withState('useMyLocationClicked', 'setUseMyLocationClicked', false)

const withFormInitialization = lifecycle({
  componentDidMount() {
    if (this.props.searchMask) {
      // replace initialValues with this solution since initialValues introduced extremely strange behavior
      this.props.change(LOCATION_FINDER_FORM, LOCATION_FINDER_INPUT, this.props.searchMask)
    }
  }
})

export default compose(
  withUseMyLocationClickedState,
  connect(null, { change, activateGoogleOptimize, reset }),
  withFormInitialization
)(StoreLocatorNoResults)
